import { Button, Divider, Menu, notification, Space, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { ReactComponent as AccountSvg } from "../../../../Assets/Account-2.svg";
import { ReactComponent as HomeSvg } from "../../../../Assets/Home.svg";
import icon from "../../../../Assets/icon2.png";
import logout from "../../../../Assets/logout.png";
import logoutGraphic from "../../../../Assets/logout_graphic.png";
import { ReactComponent as MoreSvg } from "../../../../Assets/Others.svg";
import { translation } from "../../../../i18n/translationConstant";
import { userInformation } from "../../../../redux/actions";
import { UserRespose } from "../../../../redux/Reducer/userReducer";
import store from "../../../../redux/store";
import "./index.css";
import {
  getLocalStorageItem,
  localStorageConstants,
  setAccessToken,
  setPhoneNumber,
  setRefreshToken,
  setSessionId,
  setVuaId,
} from "../../../../Services/LocalStorageServices";
import { getUser } from "../../../../Services/UserProfileServices";
import { Routes } from "../../../../Utils/Constants/routes";
import CommonModal from "../CommonModal";
import AccessibilityControls from "../AccessibilityControls";
import Footer from "../../../../Footer";
import { InfoCircleOutlined } from "@ant-design/icons";

const Menubar: React.FC<{
  setUser: (user: any) => void;
  setHeader: () => void;
  user: UserRespose;
}> = ({ setUser, setHeader, user }) => {
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const [activeKey, setActiveKey] = useState(
    location.pathname === Routes.account
      ? 1
      : location.pathname.includes(Routes.consent)
      ? 0
      : location.pathname.includes(Routes.more)
      ? 2
      : -1
  );

  useEffect(() => {
    const accessToken = getLocalStorageItem(localStorageConstants.accessToken);

    if (accessToken && user.vuaId === "")
      getUser().then((res) => {
        setUser(res.data);
      });
  }, [setUser, user]);

  const onMenuItemSelect = () => {
    setHeader();
  };

  useEffect(() => {
    if (
      (activeKey === 0 && location.pathname.includes(Routes.consent)) ||
      (activeKey === 2 && location.pathname.includes(Routes.more))
    )
      return;
    else
      setActiveKey(
        location.pathname === Routes.account
          ? 1
          : location.pathname.includes(Routes.consent)
          ? 0
          : location.pathname.includes(Routes.more)
          ? 2
          : -1
      );
  }, [location.pathname, activeKey]);

  const menuBarItems = [
    {
      name: t("Home"),
      route: Routes.consent,
      icon: (
        <HomeSvg
          className={activeKey === 0 ? "iconFill" : ""}
          height={32}
          width={32}
        />
      ),
    },
    {
      name: t("Accounts"),
      route: Routes.account,
      icon: (
        <AccountSvg
          className={activeKey === 1 ? "iconFill" : ""}
          height={32}
          width={32}
        />
      ),
    },
    {
      name: t("More"),
      route: Routes.more,
      icon: (
        <MoreSvg
          className={activeKey === 2 ? "iconFill" : ""}
          height={32}
          width={32}
        />
      ),
    },
  ];

  const confirmLogout = () => {
    setAccessToken("");
    setRefreshToken("");
    setPhoneNumber("");
    setVuaId("");
    setSessionId("");
    history.push(Routes.login);

    notification.warning({
      message: t("lblLogoutSuccess"),
    });
  };

  const logoutUser = () => {
    setIsLogoutModalVisible(true);
  };

  return (
    <div className={`subClass`}>
      <Menu className={` menubarRoot`} onClick={onMenuItemSelect} mode="inline">
        <div className="brandingDiv">
          <img
            alt={t("lblInkLogo")}
            src={icon}
            height={70}
            width={140}
          />

          <div className="usename">
            <div className="vuaIdLabel">
              <Typography.Text className="brandingLable">
                AA ID (VUA)
              </Typography.Text>

              <Tooltip
                title={t("lblVuaIdInfo")}
                placement="right"
              >
                <InfoCircleOutlined
                  className="vuaIdInfoIcon"
                  aria-label={t("lblVuaIdInfo")}
                />
              </Tooltip>
            </div>
            <Typography.Text className="brandingName">
              {user.vuaId}
            </Typography.Text>
          </div>
        </div>

        <Divider
          style={{
            marginTop: 0,
            borderWidth: "initial",
            marginBottom: 0,
          }}
        />

        {menuBarItems.map((item, index) => (
          <Menu.Item
            className={`menuHighlightColor menuTextColor menubar`}
            key={index}
            icon={item.icon}
          >
            <NavLink
              className={`${
                activeKey === index ? "primaryColor" : ""
              } menuTextColor`}
              exact={true}
              to={item.route}
            >
              {t(item.name)}
            </NavLink>
          </Menu.Item>
        ))}
      </Menu>

      <CommonModal
        visible={isLogoutModalVisible}
        onCancel={() => setIsLogoutModalVisible(false)}
      >
        <div className="logoutModalContent">

          {/* Close / Title */}
          <Typography.Text className="logoutModalTitle">
            {t("lblLogout")}
          </Typography.Text>

          {/* Illustration */}
          <div className="logoutModalImageWrapper">
            <img
              src={logoutGraphic}
              alt={t("lblLogoutIllustration")}
              className="logoutModalImage"
            />
          </div>

          {/* Message */}
          <Typography.Text className="logoutModalMessage">
            {t("lblLogoutConfirm1")}
          </Typography.Text>

          <Typography.Text className="logoutModalMessage logoutModalMessageSecondary">
            {t("lblLogoutConfirm2")}
          </Typography.Text>

          {/* Actions */}
          <div className="logoutModalActions">

            <Button
              className="logoutCancelButton"
              onClick={() => setIsLogoutModalVisible(false)}
            >
              {t(translation.lblCancel)}
            </Button>

            <Button
              className="logoutConfirmButton"
              onClick={confirmLogout}
            >
              {t(translation.lblLogout)}
            </Button>

          </div>
        </div>
      </CommonModal>

      <div className="sidebarBottomSection">

        {/* Accessibility controls */}
        <div className="sidebarAccessibility">
          <AccessibilityControls showLanguage={true} />
        </div>

        {/* Logout */}
        <div className="userInfo" onClick={logoutUser}>
          <img
            src={logout}
            alt=""
            aria-hidden="true"
          />

          <Typography.Text className="logoutTypo">
            {t("lblLogout")}
          </Typography.Text>
        </div>

        {/* RBI trust tagline */}
        <div className="sidebarTrustFooter">
          <Divider className="sidebarFooterDivider" />

          <div className="sidebarFooterText">
            <Typography.Text className="sidebarFooterName">
              {t("lblCompanyName")}
            </Typography.Text>

            <Typography.Text className="sidebarFooterTagline">
              {t("lblRbiRegulatedAa")}
            </Typography.Text>
          </div>
        </div>

      </div>
    </div>
  );
};

const mapDispatchToProps = () => {
  return {
    setUser: (user: any) => store.dispatch(userInformation(user)),
  };
};

const mapStateToProps = (state: any) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(Menubar);